import { useCallback, useEffect, useRef, useState } from "react";
import { getCJWManageHistory } from "../../API/CJWManageHistoryApi";
import { getCJWDIUploadHistory } from "../../API/CJWDIUploadHistoryApi";

export const useUploadHistory = (isDIMode = false, batchId = null) => {
    const [uploadHistory, setUploadHistory] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [loadedRequestKey, setLoadedRequestKey] = useState(null);
    const latestRequest = useRef(0);
    const requestKey = `${isDIMode ? "DI" : "APG_ASG"}:${batchId || ""}`;
    const fetchUploadHistory = useCallback( async () => {
        const requestId = latestRequest.current + 1;
        latestRequest.current = requestId;
        setLoading(true);
        try{
            const data = isDIMode
                ? await getCJWDIUploadHistory(batchId ? { batchId } : undefined)
                : await getCJWManageHistory();
            if (latestRequest.current === requestId) {
                setUploadHistory(data || []);
            }
        }catch (error) {
            console.error("Error fetching upload history:", error);
            if (latestRequest.current === requestId) {
                setUploadHistory([]);
            }
        } finally {
            if (latestRequest.current === requestId) {
                setLoadedRequestKey(requestKey);
                setLoading(false);
            }
        }
    }, [isDIMode, batchId, requestKey]);

    const fetchFilterUploads = useCallback( async (params) => {
        try{
            let data;
            if (isDIMode) {
                data = await getCJWDIUploadHistory(params);
            } else if (params) {
                data = await getCJWManageHistory(params);
            }
            return data;
        }catch (error) {
            console.error("Error fetching upload history:", error);
        } finally {
            setLoading(false);
        }
    }, [isDIMode]);

    useEffect(() => {
        fetchUploadHistory();
    }, [fetchUploadHistory]);

    return {
        fetchUploadHistory,
        fetchFilterUploads,
        uploadHistory: loadedRequestKey === requestKey ? uploadHistory : [],
        page,
        setPage,
        loading: loading || loadedRequestKey !== requestKey
    };
};
